import { Box, Modal, IconButton, Stack, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
import { Header } from "Components/Shared/BanksList/BankButton/Components/BankRatingDetail/Header";
import { NotRecommendedInfobox } from "Components/Shared/BanksList/BankButton/Components/BankRatingDetail/NotRecommendedInfobox";
import { PrimaryButton } from "Components/Shared/Buttons/PrimaryButton";
import type { Bank } from "Infrastructure/Api/Api";
import { Trans } from "react-i18next";
import {
  Resources,
  getResourcePath,
  useResource,
} from "Translations/Resources";
import { BOTTOM_MENU_HEIGHT } from "Components/Layout/Menu/BottomMenu";

const VERTICAL_MARGIN = "100px";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  bank: Bank;
};

export const NotRecommendedWarningModal = ({
  isOpen,
  onClose,
  onConfirm,
  bank,
}: Props) => {
  const { t } = useResource();

  const maxHeight = `calc(100dvh - ${VERTICAL_MARGIN} - ${BOTTOM_MENU_HEIGHT})`;

  return (
    <Modal open={isOpen} onClose={onClose} disableRestoreFocus>
      <Box
        role="dialog"
        aria-modal="true"
        sx={({ palette, shadows }) => ({
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          border: `1px solid ${palette.grey[200]}`,
          boxShadow: shadows[3],
          borderRadius: "10px",
          width: { xs: "92vw", sm: "min(92vw, 600px)" },
          maxWidth: 600,
          maxHeight,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          backgroundColor: palette.background.paper,
        })}
      >
        <Box
          position="relative"
          sx={{ maxHeight: "inherit", overflowY: "auto", p: 5 }}
        >
          <IconButton
            aria-label={t(Resources.Common.Back)}
            onClick={onClose}
            size="small"
            sx={{ position: "absolute", top: 8, right: 8, zIndex: 1 }}
          >
            <Close fontSize="small" />
          </IconButton>
          <Stack gap={4}>
            <Header bank={bank} isInModal />
            <NotRecommendedInfobox bank={bank} />
            <Typography color="error" fontWeight={500}>
              <Trans
                i18nKey={getResourcePath(
                  Resources.BankRating.Banks[bank].NotRecommended
                    ?.WarningText ?? "",
                )}
                components={{ linebreak: <br /> }}
              />
            </Typography>
            <Stack gap={2}>
              <PrimaryButton
                color="error"
                variant="outlined"
                onClick={onConfirm}
                fullWidth
              >
                <Typography fontWeight={700} fontSize={16}>
                  {t(
                    Resources.BankRating.Banks[bank].NotRecommended
                      ?.RiskItButton ?? "",
                  )}
                </Typography>
              </PrimaryButton>
              <PrimaryButton color="primary" onClick={onClose} fullWidth>
                {t(Resources.BankRating.NotRecommended.BetterButton)}
              </PrimaryButton>
            </Stack>
          </Stack>
        </Box>
      </Box>
    </Modal>
  );
};
